import React, { useState } from "react";

import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";

import { Country } from "../../../models/country";
import CountryService from "../../../services/country.service";
import AutoSuggest from "../AutoSuggest";
import useStyles from "./styles";

interface FlagSelectProps {
  error?: boolean;
  errorMessage?: string;
  required?: boolean;
  label?: string;
  disabled?: boolean;
  country?: Country;
  placeholder?: string;
  onChange?: (country: Country) => void;
}

export function CountrySuggest({
  error,
  errorMessage,
  onChange,
  country,
  required,
  label,
  disabled,
  placeholder,
}: FlagSelectProps) {
  const [countries, setCountries] = useState<Country[]>([]);

  const classes = useStyles();

  useQuery(
    ["countries"],
    () =>
      CountryService.getAll({
        orderBy: JSON.stringify(["name", "ASC"]),
      }),
    {
      onSuccess: (response) => {
        if (response && response.data && response.data?.length > 0) {
          setCountries(
            response?.data?.sort((countryA, countryB) => {
              if (
                String(countryA.name || "").toLowerCase() >
                String(countryB.name || "").toLowerCase()
              )
                return 1;
              if (
                String(countryA.name || "").toLowerCase() <
                String(countryB.name || "").toLowerCase()
              )
                return -1;

              return 0;
            })
          );
        }
      },
    }
  );

  const getLinkByCode = (code?: string, defaultValue?: string) => {
    if (code || defaultValue)
      return `https://flagcdn.com/w80/${
        code ? code?.toLowerCase() : defaultValue?.toLowerCase()
      }.png`;

    return "";
  };

  return (
    <AutoSuggest
      label={label}
      error={error}
      disabled={disabled}
      errorMessage={errorMessage}
      inputValue={country?.name || ""}
      options={countries}
      getOptionLabel={(option) => (option.name ? option.name : "")}
      onChange={(value: Country | null) => {
        if (value && onChange) onChange(value);
      }}
      placeholder={placeholder}
      renderOption={(props, option) => (
        <div {...props}>
          <div className={classNames(classes.flag, classes.flagSelect)}>
            <img
              loading="lazy"
              width="30"
              height="20"
              src={getLinkByCode(option?.code)}
              alt={option?.code}
            />
            <span>{option.name}</span>
          </div>
        </div>
      )}
      required={required}
      InputProps={{
        autoComplete: "new-password",
        startAdornment: (
          <div className={classNames(classes.flag, classes.flagInput)}>
            <img
              loading="lazy"
              width="30"
              height="20"
              src={getLinkByCode(country?.code, "AU")}
              alt={country?.code}
            />
            <span>{country?.code}</span>
          </div>
        ),
      }}
    />
  );
}
